import { render, staticRenderFns } from "./consumeWalletList.vue?vue&type=template&id=077d2904&scoped=true&"
import script from "./consumeWalletList.vue?vue&type=script&lang=js&"
export * from "./consumeWalletList.vue?vue&type=script&lang=js&"
import style0 from "./consumeWalletList.vue?vue&type=style&index=0&id=077d2904&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d2904",
  null
  
)

export default component.exports